import React from 'react';
import { Router, Route, Routes, Navigate } from 'react-router-dom';
import Form from './Form';
import Home from './Home';
import Success from './Success';
import Draft from './Draft';
import {ErrorBoundary} from "./Form/errors";

const index = () => {
    console.log('ON2AIR FORMS', window.location)
  return (
      <ErrorBoundary>
    <Routes>
      <Route element={<Success mode={'dev'} />} path="/form/dev/success/:root_code/:id" />
      <Route element={<Success />} path="/form/success/:root_code/:id" />
      <Route element={<Draft />} path="/form/draft/:root_code/:id" />
        <Route path="/form/dev/:root_code">
            <Route path=":record_id" element={<Form mode={'dev'} />} />
            <Route path="" element={<Form mode={'dev'} />} />
        </Route>
      <Route path="/form/:root_code">
        <Route path=":record_id" element={<Form />} />
        <Route path="" element={<Form />} />
      </Route>

      <Route element={<Home />} path="form/" />
      <Route path="/" element={<Navigate to="/form" replace />} />
    </Routes>
      </ErrorBoundary>
  );
};

export default index;
